var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemoveOrange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "21px",
    viewBox: "0 0 20 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "DB3BBF81-CD46-4787-B711-8DBED8FD7EDC") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Alerts-Page---DD",
    transform: "translate(-1057.000000, -343.000000)",
    stroke: "#F16334",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-24",
    transform: "translate(1041.000000, 245.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-23",
    transform: "translate(0.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11-Copy-3",
    transform: "translate(0.000000, 68.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-20",
    transform: "translate(16.000000, 19.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 3.45454545,
    y: 3.81818182,
    width: 13.0909091,
    height: 15.2727273
  }), /*#__PURE__*/React.createElement("line", {
    x1: -1.44328993e-14,
    y1: 3.81818182,
    x2: 20,
    y2: 3.81818182,
    id: "Path-3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.63636364,
    y1: 0.545454545,
    x2: 14.3636364,
    y2: 0.545454545,
    id: "Path-3-Copy"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(7.272727, 6.910809)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.545454545,
    y1: 0,
    x2: 0.545454545,
    y2: 8.72727273,
    id: "Path-4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.90909091,
    y1: 0,
    x2: 4.90909091,
    y2: 8.72727273,
    id: "Path-4-Copy"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveOrange);
export default __webpack_public_path__ + "static/media/remove_orange.2b21f7d93e46cd14859a91c4f759cf68.svg";
export { ForwardRef as ReactComponent };